import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { 
  checkAddPermission, 
  checkDeletePermission, 
  checkEditPermission, 
  checkViewPermission, 
  fetchProductOriginDataList, 
  filteredCategories, 
  handleAddSingleData, 
  handleBlurData, 
  handleExportFile, 
  handleImportClickFile, 
  handleInputChangeData, 
  handleUpdateAllCheckbox, 
  handleUpdateData, 
  handleUpdateDataCheckbox, 
  handleUpdateSingleData, 
  resetForm, 
  resetFormData, 
  setupEditFormData, 
  TableFooter, 
  toggleActiveStatusData 
} from "../../../Utils/helper";
import Import from "../../../Utils/import";
import { getApi } from "../../../Services/apiService";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../../Utils/deleteModal";

function Supplier() {
  const navigate = useNavigate();
  const dropdownRef = useRef()
  const [methodType, setMethodType] = useState('');
  const { data } = useSelector((state) => state.roleData);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [supplier, setSupplier] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [supplierToEdit, setSupplierToEdit] = useState(null);
  const [formData, setFormData] = useState({
    name_en: '',
    name_tc: '',
    code: '',
    origin: '',
    product_origin_id: '',
    is_active: true
  });
  const [formDataCopy, setFormDataCopy] = useState({
    name_en: '',
    name_tc: '',
    code: '',
    origin: '',
    product_origin_id: '',
    is_active: true
  });
  const [touched, setTouched] = useState({
    name_tc: false,
    name_en: false,
    origin: false,
    code: false
  });
  const [errors, setErrors] = useState({
    name_en: '',
    name_tc: '',
    code: '',
    origin: ''
  });
  
  const [supplierToDelete, setSupplierToDelete] = useState(null);
  const [showImportModal, setShowImportModal] = useState(false);
  const [importFile, setImportFile] = useState(null);
  const [importErrors, setImportErrors] = useState({
    file: '',
    general: ''
  });
  const [searchQuery, setSearchQuery] = useState('');
  const [origin, setOrigin] = useState([]);
  const [perPage,setPerPage] = useState(50)
  const [currentPage, setCurrentPage] = useState(1);
  const [pageCount, setPageCount] = useState(null)
  const [originDropdown, setOriginDropdown] = useState(false)
  const [searchTerm,setSearchTerm] = useState('')
  const [filterDatas,setFilterData] = useState([])

  useEffect(() => {
    fetchProductOriginDataList('',setOrigin);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOriginDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const validateField = (name, value) => {
    let error = '';

    switch (name) {
      case 'name_en':
        if (!value.trim()) error = 'English name is required';
        else if (value.length > 100) error = 'English name must be less than 100 characters';
        break;
      case 'name_tc':
        if (!value.trim()) error = 'Traditional Chinese name is required';
        else if (value.length > 100) error = 'Traditional Chinese name must be less than 100 characters';
        break;
      case 'code':
        if (!value.trim()) error = 'Code is required';
        else if (value.length > 50) error = 'Code must be less than 50 characters';
        break;
      case 'origin':
        if (!value) error = 'Origin is required';
        break;
      default:
        break;
    }

    return error;
  };

  const validateForm = () => {
    const newErrors = {
      name_en: validateField('name_en', formData.name_en),
      name_tc: validateField('name_tc', formData.name_tc),
      code: validateField('code', formData.code),
      origin: validateField('origin', formData.origin)
    };

    setErrors(newErrors);

    return !Object.values(newErrors).some(error => error);
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    setTouched(prev => ({ ...prev, [name]: true }));

    const error = validateField(name, value);
    setErrors(prev => ({ ...prev, [name]: error }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: validateField(name, value)
      }));
    }
  };

  const fetchSuppliers = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await getApi(`/suppliers?search=${encodeURIComponent(searchQuery)}&per_page=${perPage}&page=${currentPage}`);

      if (response?.success) {
        setSupplier(response.data.suppliers?.data || []);
        setPageCount(response?.data?.suppliers?.last_page)
      } else {
        setError(response?.msg || 'Failed to fetch suppliers');
      }
    } catch (error) {
      setError(error.message || 'Failed to fetch suppliers');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchSuppliers();
    }, 500);

    return () => clearTimeout(timer);
  }, [searchQuery,perPage,currentPage]);

  const handleSubmit = async () => {
    // Mark all fields as touched
    setTouched({
      name_tc: true,
      name_en: true,
      origin: true,
      code: true
    });

    if (!validateForm()) {
      return;
    }

    if (methodType === 'add') {
      await handleAddSingleData(
        setIsLoading,
        formData,
        fetchSuppliers,
        setMethodType,
        formDataCopy,
        setTouched,
        setError,
        '/suppliers',
        'supplier',
        setFormData
      );
    } else if (methodType === 'edit') {
      await handleUpdateSingleData(
        supplierToEdit,
        setIsLoading,
        fetchSuppliers,
        formData,
        setMethodType,
        setFormData,
        setError,
        setTouched,
        `/suppliers/${supplierToEdit?.id}`,
        'supplier',
        formDataCopy
      );
    }
  };

  const handlePageClick = (selected) => {
    setCurrentPage(selected);
  };

  useEffect(() => {
    if (searchTerm !== '') {
      // filterData()
      if (originDropdown) {
        const data = filteredCategories(searchTerm, origin);
        setFilterData(data?.length > 0 ? data : []);
      } 
    }
    
  }, [searchTerm])

  return (
    <div className="RightSideDiv product-single  buyer-page-ui">
      {showImportModal && (
        <Import
          setImportFile={setImportFile}
          importFile={importFile}
          searchQuery={searchQuery}
          fetchData={fetchSuppliers}
          setShowImportModal={setShowImportModal}
          routeEnd={'/suppliers/import'}
          routeexport={`/suppliers/export`}
          type={'Supplier'}
        />
      )}

      {showDeleteModal && (
        <DeleteModal
          setShowDeleteModal={setShowDeleteModal}
          todelete={supplierToDelete}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          settoDelete={setSupplierToDelete}
          fetchData={fetchSuppliers}
          route={`/suppliers/${supplierToDelete?.id}`}
          type={'supplier'}
        />
      )}

      {methodType === '' && (
        <div className="row">
          <div className="col-sm-12">
            <div className="setting-right setting-right-table table-border-show">
              <div className="table-header table-actions">
                <div className="search-card ">
                  <img src={window.getPublicUrl('/assets/images/search-icon.png')} alt="" />
                  <input
                    type="text"
                    className="search-input"
                    placeholder="Search Supplier..."
                    value={searchQuery}
                    onChange={(e) => {setSearchQuery(e.target.value);setCurrentPage(1)}}
                  />
                </div>
                {/* <div className="table-actions"> */}
                {checkAddPermission(data?.permissions, 'supplier_list') && (

                  <button className="btn" onClick={() => handleImportClickFile(setShowImportModal, setImportFile, setImportErrors)}>
                    <img src={window.getPublicUrl('/assets/images/import.png')} alt="" />
                    Import
                  </button>
                )}
                  <button className="btn" onClick={() => handleExportFile(supplier, searchQuery, 'supplier.xlsx', '/suppliers/export')}>
                    <img src={window.getPublicUrl('/assets/images/export.png')} alt="" />
                    Export
                  </button>
                  {checkAddPermission(data?.permissions, 'supplier_list') && (
                    <button className="btn add" onClick={() => { setMethodType('add'); resetFormData(setFormData, setError, null, formDataCopy); }}>
                      + Add New Supplier
                    </button>
                  )}
                {/* </div> */}
              </div>

              <div className="permission-table-inner category-table">
                <table className="custom-table table-striped">
                  <thead>
                    <tr>
                      <th className="checkbox">
                        <label className="checbox-cs">
                          <input type="checkbox" onClick={(e) => handleUpdateAllCheckbox(e?.target?.checked, setSupplier)} />
                          <span className="checkmark"></span>
                        </label>
                      </th>
                      <th className="code">Code</th>
                      <th className="name">Name(EN)</th>
                      <th className="name">Name(TC)</th>
                      <th className="origin">Origin</th>
                      <th className="action">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      <tr>
                        <td colSpan="6" className="text-center">
                          <div className="spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </td>
                      </tr>
                    ) : error ? (
                      <tr>
                        <td colSpan="6" className="text-center text-danger">{error}</td>
                      </tr>
                    ) : supplier?.length === 0 ? (
                      <tr>
                        <td colSpan="6" className="text-center">No suppliers found</td>
                      </tr>
                    ) : (
                      supplier?.length > 0 && supplier?.map((supplier, index) => (
                        <tr key={index}>
                          <td className="checkbox">
                            <label className="checbox-cs">
                              <input
                                type="checkbox"
                                onClick={(e) => handleUpdateDataCheckbox(supplier, e, setSupplier)}
                                checked={supplier?.status}
                              />
                              <span className="checkmark"></span>
                            </label>
                          </td>
                          <td className="code">{supplier?.code}</td>
                          <td className="name">{supplier?.name_en}</td>
                          <td className="name">{supplier?.name_tc}</td>
                          <td className="origin">{supplier?.origin}</td>
                          <td className="action action-cs">
                            <div className="dropdown">
                               {(checkEditPermission(data?.permissions, 'supplier_list') || checkDeletePermission(data?.permissions, 'supplier_list')) && (
                              <button class=" dropdown-toggle action-btn" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                Action <img src={window.getPublicUrl('/assets/images/action-drops.png')} alt="Actions" className="ps-2" />
                              </button>
                               )}
                              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                              
                                <li>
                                  {checkEditPermission(data?.permissions, 'supplier_list') && (
                                    <a href="#" className="dropdown-item" onClick={(e) => {
                                      e.preventDefault();
                                      setupEditFormData(supplier, setFormData, setMethodType, setSupplierToEdit, formDataCopy);
                                    }}> 
                                        Edit
                                    </a>
                                  )}
                                </li>
                                {/* <li>
                                  {checkEditPermission(data?.permissions, 'supplier_list') && (
                                    <a href="#" className="dropdown-item" onClick={(e) => {
                                      e.preventDefault();
                                      toggleActiveStatusData(
                                        `/suppliers/${supplier?.id}`,
                                        { is_active: !supplier.is_active },
                                        setIsLoading,
                                        fetchSuppliers,
                                        navigate
                                      );
                                    }}>
                                      {supplier.is_active ? 'Make Inactive' : 'Make Active'}
                                    </a>
                                  )}
                                </li> */}
                                <li>
                                  {checkDeletePermission(data?.permissions, 'supplier_list') && (
                                    <a href="#" className="dropdown-item" onClick={(e) => {
                                      e.preventDefault();
                                      setSupplierToDelete(supplier);
                                      setShowDeleteModal(true);
                                    }}>
                                      Delete
                                    </a>
                                  )}
                                </li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
              <div className="table-footer d-flex justify-content-between table-pagination">
                <select name="" id="" className='affter-change-cs page' value={perPage} onChange={(e) => {setPerPage(Number(e.target.value)); setCurrentPage(1) }}>
                <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="250">250</option>
                    <option value="500">500</option>
                  </select>
                  <div className=''>
                    <TableFooter
                      pageCount={pageCount}
                      handlePageClick={handlePageClick}
                      currentPage={currentPage}
                    />
                  </div>
                </div>
            </div>
          </div>
        </div>
      )}

      {/* Add Supplier Form */}
      {methodType === 'add' && (
        <div className="row">
          <div className="col-sm-12">
            <div className="setting-right position-relative">
              <h3>Add New Supplier</h3>
              <img
                src={window.getPublicUrl('/assets/images/close.svg')}
                className="close"
                alt="Close"
                onClick={() => {
                  setMethodType('');
                  setError(null);
                  setFormData({
                    name_en: '',
                    name_tc: '',
                    code: '',
                    origin: '',
                    product_origin_id: '',
                    is_active: true
                  })
                  setOriginDropdown(false)
                  // resetFormData(setFormData, setError, null, formDataCopy);
                }}
              />
              <div className="setting-inner all-add-page-scroll">
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>Code<strong>*</strong></label>
                      <input
                        type="text"
                        className={`form-control ${touched.code && errors.code ? 'is-invalid' : ''}`}
                        placeholder="Enter code"
                        name="code"
                        value={formData.code}
                        onChange={handleInputChange}
                        onBlur={handleBlur}
                      />
                      {touched.code && errors.code && (
                        <div className="invalid-feedback">{errors.code}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>Name(EN)<strong>*</strong></label>
                      <input
                        type="text"
                        className={`form-control ${touched.name_en && errors.name_en ? 'is-invalid' : ''}`}
                        placeholder="Enter Supplier Name"
                        name="name_en"
                        value={formData.name_en}
                        onChange={handleInputChange}
                        onBlur={handleBlur}
                      />
                      {touched.name_en && errors.name_en && (
                        <div className="invalid-feedback">{errors.name_en}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>Name(TC)<strong>*</strong></label>
                      <input
                        type="text"
                        className={`form-control ${touched.name_tc && errors.name_tc ? 'is-invalid' : ''}`}
                        placeholder="Enter Supplier Name"
                        name="name_tc"
                        value={formData.name_tc}
                        onChange={handleInputChange}
                        onBlur={handleBlur}
                      />
                      {touched.name_tc && errors.name_tc && (
                        <div className="invalid-feedback">{errors.name_tc}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group position-relative">
                      <label>Origin<strong>*</strong></label>
                      {/* value={formData?.origin} */}
                      <input type="text" placeholder="Origin" class={`input-selection ${touched.origin && errors.origin ? 'is-invalid' : ''}`} value={originDropdown?searchTerm:formData?.origin} onChange={(e)=>setSearchTerm(e?.target?.value)}  onClick={()=>{setOriginDropdown(!originDropdown);setSearchTerm('')}}></input>
                      {originDropdown &&
                      <div className="custom-select-cs select-option w-100" ref={dropdownRef}>
                      {/* <ul> */}
                      {origin && (searchTerm==='' ? origin?.length >0 :filterDatas?.length>0) ?(searchTerm===''?origin:filterDatas).map((x, ind) => {
                         const selectedOrigin = origin.find(o => o.name === x?.name);
                         return(
                        // <li onClick={(e) => {
                        //   const selectedOrigin = origin.find(o => o.name === x?.name);
                        //   setFormData(prev => ({
                        //     ...prev,
                        //     origin: x?.name,
                        //     product_origin_id: selectedOrigin?.id || ""
                        //   }));
                        //   handleInputChange(e);
                        // }}
                        // className={selectedOrigin?.id ===formData?.product_origin_id ?'tick':''}
                        // >

                        //   {/* <span>{selectedOrigin?.id ===formData?.product_origin_id &&'tick'}</span> */}
                        //   {x?.name}</li>
                        <span key={ind}>
                            <label className="checbox-cs">
                              <input
                                type="checkbox"
                                checked={selectedOrigin?.id ===formData?.product_origin_id}
                                onChange={(e) => {
                                  setFormData(prev => ({
                                        ...prev,
                                        origin: x?.name,
                                        product_origin_id: selectedOrigin?.id || ""
                                      }));
                                  handleInputChange(e);
                                }}
                              />
                              <span className="checkmark"></span>
                            </label>
                            {x?.name}
                          </span>
                      )})
                      :
                            <span className="no-data-available">No Origin Available</span>
                    }
                      {/* </ul> */}
                      </div>
}
                      {/* <select 
                        name="origin" 
                        className={`form-control ${touched.origin && errors.origin ? 'is-invalid' : ''}`} 
                        value={formData.origin}
                        onChange={(e) => {
                          const selectedOrigin = origin.find(o => o.name === e.target.value);
                          setFormData(prev => ({
                            ...prev,
                            origin: e.target.value,
                            product_origin_id: selectedOrigin?.id || ""
                          }));
                          handleInputChange(e);
                        }}
                        onBlur={handleBlur}
                      >
                        <option value="">Select Origin</option>
                        {origin && origin?.length > 0 && origin.map((x, ind) => (
                          <option value={x?.name} key={ind}>{x?.name}</option>
                        ))}
                      </select> */}
                      {touched.origin && errors.origin && (
                        <div className="invalid-feedback">{errors.origin}</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="button-settings">
                <div className="col-sm-12">
                  <div className="d-flex justify-content-end gap-3">
                    <button className="reset" onClick={() => {resetFormData(setFormData, setError, null, formDataCopy);setError(null)}}>
                      Reset
                    </button>
                    <button className="save" onClick={handleSubmit}>
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Edit Supplier Form */}
      {methodType === 'edit' && (
        <div className="row">
          <div className="col-sm-12">
            <div className="setting-right position-relative">
              <h3>Edit Supplier</h3>
              <img
                src={window.getPublicUrl('/assets/images/close.svg')}
                className="close"
                alt="Close"
                onClick={() => {
                  setMethodType('');
                  setError(null);
                  setFormData({
                    name_en: '',
                    name_tc: '',
                    code: '',
                    origin: '',
                    product_origin_id: '',
                    is_active: true
                  })
                  setOriginDropdown(false)
                  // resetFormData(setFormData, setError, supplierToEdit, formDataCopy);
                }}
              />
              <div className="setting-inner">
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>Code<strong>*</strong></label>
                      <input
                        type="text"
                        className={`form-control ${touched.code && errors.code ? 'is-invalid' : ''}`}
                        name="code"
                        placeholder="Enter code"
                        value={formData.code}
                        onChange={handleInputChange}
                        onBlur={handleBlur}
                      />
                      {touched.code && errors.code && (
                        <div className="invalid-feedback">{errors.code}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>Name(EN)<strong>*</strong></label>
                      <input
                        type="text"
                        className={`form-control ${touched.name_en && errors.name_en ? 'is-invalid' : ''}`}
                        name="name_en"
                        placeholder="Enter Supplier Name"
                        value={formData.name_en}
                        onChange={handleInputChange}
                        onBlur={handleBlur}
                      />
                      {touched.name_en && errors.name_en && (
                        <div className="invalid-feedback">{errors.name_en}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>Name(TC)<strong>*</strong></label>
                      <input
                        type="text"
                        className={`form-control ${touched.name_tc && errors.name_tc ? 'is-invalid' : ''}`}
                        name="name_tc"
                        placeholder="Enter Supplier Name"
                        value={formData.name_tc}
                        onChange={handleInputChange}
                        onBlur={handleBlur}
                      />
                      {touched.name_tc && errors.name_tc && (
                        <div className="invalid-feedback">{errors.name_tc}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group position-relative">
                      <label>Origin<strong>*</strong></label>
                      {/* <select
                        name="origin"
                        className={`form-control ${touched.origin && errors.origin ? 'is-invalid' : ''}`}
                        value={formData.origin}
                        onChange={(e) => {
                          const selectedOrigin = origin.find(o => o.name === e.target.value);
                          setFormData(prev => ({
                            ...prev,
                            origin: e.target.value,
                            product_origin_id: selectedOrigin?.id || ""
                          }));
                          handleInputChange(e);
                        }}
                        onBlur={handleBlur}
                        disabled={methodType==='edit'}
                      >
                        <option value="">Select Origin</option>
                        {origin && origin?.length > 0 && origin.map((x, ind) => (
                          <option value={x?.name} key={ind}>{x?.name}</option>
                        ))}
                      </select> */}
                       <input type="text" placeholder="Origin" class="input-selection" value={formData?.origin} onClick={()=>setOriginDropdown(!originDropdown)}></input>
                      {originDropdown &&
                      <div className="custom-select-cs" ref={dropdownRef}>
                      <ul>
                      {origin && origin?.length > 0 && origin.map((x, ind) => (
                        <li onClick={(e) => {
                          const selectedOrigin = origin.find(o => o.name === x?.name);
                          setFormData(prev => ({
                            ...prev,
                            origin: x?.name,
                            product_origin_id: selectedOrigin?.id || ""
                          }));
                          handleInputChange(e);
                          setOriginDropdown(!originDropdown)
                        }}>{x?.name}</li>
                      ))}
                      </ul>
                      </div>
}
                      {touched.origin && errors.origin && (
                        <div className="invalid-feedback">{errors.origin}</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="button-settings">
                <div className="col-sm-12">
                  <div className="d-flex justify-content-end gap-3">
                    <button className="reset" onClick={() => {resetFormData(setFormData, setError, supplierToEdit, formDataCopy);setError(null)}}>
                      Reset
                    </button>
                    <button className="save" onClick={handleSubmit}>
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Supplier;